/* global G */
import { useCallback, useContext, useEffect, useRef, useState } from 'react'
import ApplicationContext from '@platform/react/context/application'
import { findPosition } from 'platform/adapter/cart/helper'

/**
 * useCart Hook
 *
 * Fetches the current cart and returns it.
 *
 * @returns {{cart: unknown}}
 */
const useCart = ({ id, name } = {}) => {
  const { eventBus } = useContext(ApplicationContext)
  const [cart, setCart] = useState(null)
  const [position, setPosition] = useState(null)

  const handleCart = useCallback(({ detail } = {}) => {
    const { [G.DATA]: currentCart } = detail

    // Construct object anew to force rerender
    setCart({ ...currentCart })

    if (id || name) {
      setPosition(findPosition(currentCart.value.positions, { key: id, name }))
    }
  }, [id, name])

  useEffect(() => {
    eventBus.add(eventBus.type(G.CART, G.DONE), handleCart)
    eventBus.dispatch(eventBus.type(G.CART, G.READ))

    return () => {
      eventBus.remove(eventBus.type(G.CART, G.DONE), handleCart)
    }
  }, [])

  return {
    cart,
    position,
  }
}

export default useCart
